import { reduxKey, FirstTimeFlagsType } from './constants';
import { setFirstTimeFlags, unsetFirstTimeFlag } from './actions';
import { handleActions } from 'redux-actions';

const actionHandlers = handleActions<FirstTimeFlagsType, any>(
  {
    [setFirstTimeFlags.toString()]: (
      state,
      { payload: flags }: ReturnType<typeof setFirstTimeFlags>
    ) => ({ ...state, ...flags }),
    [unsetFirstTimeFlag.toString()]: (
      state,
      { payload: { flag } }: ReturnType<typeof unsetFirstTimeFlag>
    ) => ({
      ...state,
      [flag]: false,
    }),
  },
  {}
);

export default {
  [reduxKey as string]: actionHandlers,
};
